<header>
    <img id="logo" style="height: 83px; width: 150px;" src="assets/img/Osmos_logo.png">
</header>